
import { useEffect, useRef, useState } from 'react';
import './pinZakrepLight.css';
import './pinZakrepDark.css';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';

import { getMessageItem } from '../../../../redux/reducer/getMessageItem/action/action';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

export default function PinZakrep() {
    const navigate = useNavigate();
    const hidePin = useRef();
    const getDarkModoe = useSelector(darkModes => darkModes);
    const getChatInfo = useSelector(chatInfi => chatInfi.getChatInfoByIDReducer);
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const chat_filter = searchParams.get('chat_filter');
    const [zakrepItem, setzakrepItem] = useState([]);
    const hidPinFunc = () => {
        hidePin.current.style.display = "none";
    }


    useEffect(() => {
        // Здесь мы получаем конкретное сообщение для отображения закрепления
        const fetchData = async () => {
            try {
                const response = await axios.get(`/getPinMessage/api?chatID=${getChatInfo.data._id}`);
                setzakrepItem(response.data.data);

                
                // Handle response data here
            } catch (error) {
                console.error("Error fetching pinned messages:", error);
                // Handle error
            }
        };
        fetchData();

        if (chat_filter !== null) {
            dispatch(getMessageItem(`/getPinMessage/api?chatID=${getChatInfo.data._id}`));
        }
       
        
    }, [chat_filter])
// это переход закрепления сообщений и простые сообщения
    const handlePin = async () => {
        console.log(chat_filter);
        if (chat_filter == null) {
            
            navigate(`?chatID=${getChatInfo.data._id}&chat_filter=message_pin`)
            dispatch(getMessageItem(`/getPinMessage/api?chatID=${getChatInfo.data._id}`));
        } else {
           
            navigate(`?chatID=${getChatInfo.data._id}`)
            dispatch(getMessageItem(`/getItemMessages/api?chatID=${getChatInfo.data._id}`));
        }


    };
    return (
        <div ref={hidePin} className={getDarkModoe.ToggleDarkModeReducer.chekced ? "pinZakrepDarkCont" : "pinZakrepLightCont"}>

            <div className='pinZakrepInfo' onClick={handlePin}>
                <div className='pinZakrepInfoIconCont'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M7.25817 2.59426C5.18709 2.5568 3.15842 3.51904 1.88922 5.29022C1.70425 5.54834 1.52094 5.86586 1.20376 6.41526L1.18119 6.45436C1.17786 6.46013 1.17451 6.46591 1.17116 6.47172C1.13321 6.53733 1.09381 6.60545 1.06371 6.67188C0.77658 7.30559 0.977086 8.05389 1.54261 8.45914C1.60189 8.50162 1.67007 8.54092 1.73574 8.57876C1.74155 8.58211 1.74734 8.58545 1.7531 8.58878L6.89513 11.5575L3.87429 16.7898C3.7017 17.0887 3.80413 17.4709 4.10306 17.6435C4.40199 17.8161 4.78424 17.7137 4.95683 17.4148L7.97766 12.1825L13.1197 15.1513C13.1255 15.1546 13.1312 15.158 13.1371 15.1613C13.2027 15.1993 13.2708 15.2387 13.3372 15.2688C13.9709 15.5559 14.7192 15.3554 15.1245 14.7899C15.167 14.7306 15.2063 14.6624 15.2441 14.5967C15.2474 14.5909 15.2508 14.5851 15.2541 14.5794L15.2767 14.5403C15.5939 13.9909 15.7772 13.6734 15.9083 13.3841C16.8077 11.399 16.6265 9.16045 15.5579 7.38539L15.648 7.22932C16.9712 4.9375 16.1859 2.00696 13.8941 0.683778C11.6023 -0.639404 8.67177 0.145829 7.34859 2.43765L7.25817 2.59426ZM8.6225 2.76586C9.02268 2.86049 9.41838 2.99456 9.80425 3.16939C10.0935 3.30045 10.411 3.48377 10.9604 3.80098L12.6624 4.78364C13.2118 5.10081 13.5293 5.28412 13.7874 5.46909C14.1314 5.7156 14.4451 5.99095 14.7269 6.28987C15.4686 4.65087 14.8599 2.68474 13.2691 1.76631C11.6783 0.847822 9.67101 1.30383 8.6225 2.76586ZM7.55856 3.85998C5.7774 3.71642 3.9943 4.49858 2.90527 6.01832C2.76074 6.22001 2.60973 6.48005 2.26372 7.07936C2.23848 7.12308 2.22347 7.14912 2.21247 7.16896C2.20547 7.18157 2.20194 7.18854 2.20194 7.18854C2.16156 7.27865 2.18999 7.38475 2.27002 7.44259C2.27002 7.44259 2.27655 7.44686 2.28892 7.45428C2.30837 7.46596 2.33438 7.48101 2.3781 7.50625L8.06139 10.7875L13.7447 14.0687C13.7884 14.094 13.8144 14.109 13.8343 14.12C13.8461 14.1266 13.8518 14.1295 13.8536 14.1304C13.9441 14.1714 14.0505 14.1425 14.1084 14.0618C14.1063 14.0647 14.1085 14.062 14.1196 14.0435C14.1313 14.0241 14.1463 13.9981 14.1716 13.9544C14.5176 13.355 14.6673 13.0942 14.7697 12.8682C15.5426 11.1624 15.3264 9.22339 14.3071 7.75173C13.9747 7.27193 13.5569 6.84166 13.0593 6.48514C12.8576 6.34061 12.5976 6.1896 11.9983 5.84359L10.3745 4.90609C9.77518 4.56007 9.51438 4.41038 9.28837 4.30797C8.72797 4.05406 8.14328 3.9071 7.55856 3.85998Z" fill="#3361FF" />
                    </svg>
                </div>
                <div>
                    <p className='pinZakrepInfoMessageName'>Закреп. сообщение {zakrepItem.length}</p>
                    <p className='pinZakrepInfoMessage'>{zakrepItem[zakrepItem.length - 1] && zakrepItem[zakrepItem.length - 1].messageText}</p>
                </div>
            </div>

            <div className='iconContPin' onClick={hidPinFunc}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M1 1L15 15M1.00003 15L8.00003 8L15 1" stroke="#393939" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
            </div>
        </div>
    )
}